import React, { useState, useEffect } from 'react';
import api from '../lib/api';
import { Badge } from './ui/badge';

export default function NotificationBadge({ type }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    fetchCounts();
    // Refresh every 30 seconds
    const interval = setInterval(fetchCounts, 30000);
    return () => clearInterval(interval);
  }, []);

  const fetchCounts = async () => {
    try {
      if (type === 'approvals') {
        // Fetch pending approvals count separately for directors
        const response = await api.get('/pending-actions/count');
        setCount(response.data.count || 0);
      } else {
        const response = await api.get('/notifications/counts');
        if (type === 'leaves') {
          setCount(response.data.pending_leaves || 0);
        } else if (type === 'justifications') {
          setCount(response.data.pending_justifications || 0);
        } else if (type === 'notifications') {
          setCount(response.data.unread_notifications || 0);
        }
      }
    } catch (error) {
      // Silently fail for unauthorized access (non-directors trying to get approval count)
      if (error.response?.status !== 403) {
        console.error('Failed to fetch notification counts', error);
      }
    }
  };

  if (count === 0) return null;

  return (
    <Badge className="ml-2 bg-error text-white h-5 min-w-[20px] px-1.5 text-xs font-bold" data-testid={`badge-${type}`}>
      {count}
    </Badge>
  );
}
